import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { TxRadio } from './Radio';
export function TxRadioGroup({ label, options, name, onChange, value, disabled, className = '', }) {
    const [state, setState] = useState(value);
    useEffect(() => {
        setState(value);
    }, [value]);
    function onInternalChange(e) {
        setState(e.target.value);
        if (onChange) {
            onChange(e);
        }
    }
    return (React.createElement("div", { className: classNames('tx-radio-group', className) },
        label && React.createElement("div", { className: "tx-radio-group__label" }, label),
        React.createElement("fieldset", { className: "tx-radio-group__options", disabled: disabled }, options.map((option) => (React.createElement(TxRadio, { ...option, name: name, onChange: onInternalChange, className: "tx-radio-group__options__option", key: option.value, checked: state === option.value }))))));
}
//# sourceMappingURL=RadioGroup.js.map